export const DEFAULT_ZIPCODE = '23666';
export const DEFAULT_CITY = 'Hampton';
export const DEFAULT_STATE = 'VA';
export const DEFAULT_ZIPCODE_CITY_AND_REGION = '23666 - Hampton, VA';
export const DEFAULT_ZIPCODE_CITY_AND_REGION_NEW = '23666 - Hampton, VA';
export const DRUGNAME_QUERY_PARAMETER = 'q';
export const UTMSOURCE_QUERY_PARAMETER = 'utm_source';
export const UTMMEDIUM_QUERY_PARAMETER = 'utm_medium';
export const COOKIE_DEFAULT_EXPIRY_TIME = 30;
export const COOKIE_EXPIRY_WITH_SESSION = 0;
export const COOKIE_SIX_MONTH_EXPIRY_TIME = 6 * 30 * 24 * 60;
export const COOKIE_EXPIRY_24HRS = 24 * 60;
export const COOKIE_EXPIRY_2MIN = 2;
export const COOKIE_EXPIRY_14_DAYS = 14 * 24 * 60;
export const COOKIE_EXPIRY_7_DAYS = 7 * 24 * 60;
export const STICKY_BANNER_CLOSE = 'isStickyBannerClose';
export const STICKY_BANNER_COUNTER = 'stickyBannerDisplayCounter';
export const FAQ_TYPE = 'HowItWorks';
export const FAQ_TYPE_CONDITION = 'Conditions';
export const HOME_TITLE =
  'SingleCare: The Best Prescription Prices, Discounts & Coupons';
export const HOME_DESC =
  'Save up to 80% on your prescriptions with SingleCare prescription coupons.' +
  'Compare Rx prices from your local pharmacies to get the best prescription prices.';
export const HOME_CANONICAL = 'https://www.singlecare.com';
export const HOME_OG_TITLE = 'Use SingleCare to save up to 80% on your Rx';
export const HOME_OG_DESC =
  'Feeling better shouldn’t be painful. ' +
  'At SingleCare, we partner with thousands of pharmacies to help you afford ' +
  'the medication you need—regardless of insurance status.';
export const RX_TITLE =
  'Prescription Coupons, Prices, & Discount Card from SingleCare';
export const RX_DESC =
  "Save up to 80% with SingleCare's prescription coupons. " +
  'Find the lowest prices and have your prescription discount card delivered instantly!';
export const RX_META_KEYWORD =
  'affordable health care, affordable healthcare, ' +
  'discount medical services, ' +
  'medical services, health services' +
  ', discount health services, medical costs, ' +
  'health savings, discount health care';
export const RX_CANONICAL = 'https://www.singlecare.com/rx';
const year =
  new Date().getMonth() === 11 && new Date().getDate() > 11
    ? new Date().getFullYear() + 1
    : new Date().getFullYear();
export const PRESCRIPTION_TITLE = ' Coupon ' + year + ' - Up to 80% Discount';
export const PRESCRIPTION_CANONICAL =
  'https://www.singlecare.com/prescription/';
export const PRESCRIPTION_CANONICAL_ES =
  'https://www.singlecare.com/es/medicamento/';
export const OG_DESC =
  "At SingleCare we believe feeling better shouldn't be painful. " +
  'Find the best price on';
export const OG_DESC_DRUG =
  'at pharmacies like CVS, Walmart & Walgreens. ' +
  'Save up to 80% with our coupons—with or without insurance!';
export const DEFAULT_PARTNER_PID = 'SingleCare Rx';
export const DEFAULT_PARTNER_PASSWORD = 'AH@ldNiBqj#|k0M';

export const TERMS_TITLE = 'Terms and Conditions | SingleCare';
export const TERMS_DESC = 'SingleCare Terms and Conditions';
export const POLICY_TITLE = 'Privacy Policy';
export const POLICY_DESC = 'SingleCare Privacy Policy';
export const WASHINGTON_POLICY_TITLE =
  'Washington Consumer Health Privacy Policy';
export const ABOUT_US_TITLE = 'About Us';
export const ABOUT_US_DESC = 'About SingleCare';
export const RXSAVINGS_TITLE =
  'SingleCare: Affordable Health Care ' + '& Pharmacy Discount Card';
export const RXSAVINGS_DESC =
  'Use SingleCare to save on prescriptions with our pharmacy discount card. ' +
  'You can also save on health care such as dental, vision and online doctor visits.';

export const CONDITIONS_TITLE =
  'Find Medications and Treatments for Medical Conditions';
export const CONDITIONS_DESC =
  'Compare medications and common treatments for health conditions. ' +
  'Search medical conditions and chronic diseases from A to Z.';
export const DRUG_CLASS_TITLE = 'Browse Medications by Drug Class';
export const DRUG_CLASS_DESC =
  'Compare medications in common drug classes. Search prescription drugs by ' +
  'drug classification and drug category.';
export const DRUG_CLASS_TEXT_BELOW_SEARCH =
  'Drugs are organized into categories by drug classification. A class of ' +
  'drugs is a group of similar medications. The list of drugs in each drug ' +
  'class may work similarly, they may have a comparable chemical structure, ' +
  'or they could treat similar medical conditions. Use the following resource ' +
  'guides to learn more about the common drug classes, how they work, ' +
  'and what they cost.';

export const DRUG_CLASS_TEXT_BELOW_LINKS =
  'Browsing medications by drug classes can be especially helpful ' +
  'if you are looking for alternatives to a drug you’ve been prescribed. ' +
  'You may be looking for a similar drug that doesn’t cause as ' +
  'many side effects or has fewer drug interactions. Drug prices are another ' +
  'good reason to look for drug alternatives. For example, by researching ' +
  'CNS stimulants, you may find that Adderall could be more affordable ' +
  'than Vyvanse. Use these drug class guides to inform conversations ' +
  'with your healthcare provider about finding the right medication for you.';

export const DRUG_CLASS_CANONICAL = 'https://www.singlecare.com/drug-classes';

export const CONDITION_TYPE = { CAUSE: 'Cause', SYMPTOM: 'Symptom' };
export const SYMPTOMS_TITLE = 'Symptoms of Common Medical Conditions';
export const SYMPTOMS_DESC =
  'Identify common symptoms and early warning signs of health conditions. ' +
  'Search medical conditions and chronic diseases from A to Z.';
export const SYMPTOMS_CANONICAL =
  'https://www.singlecare.com/conditions-symptoms';
export const SYMPTOMS_TEXT_BELOW_SEARCH =
  'Is it just a sore throat, the common cold, a sinus infection, or something else?' +
  ' What are the symptoms of diabetes? What are the early signs of congestive heart' +
  ' failure? What’s the difference between kidney pain vs. back pain? What does ovarian' +
  ' cyst pain feel like? Early detection is key to successfully treating many medical' +
  ' conditions. Use the following resource guides to learn more about the symptoms of' +
  ' certain health conditions.';

export const SYMPTOMS_TEXT_BELOW_LINKS =
  'As you browse the following guides to symptoms, it’s important to remember that only' +
  ' a healthcare professional can diagnose your medical condition. A diagnosis often' +
  ' requires a doctor’s visit and sometimes testing. In these guides, we’ve listed common' +
  ' and serious symptoms for various medical conditions, answered frequently asked' +
  ' questions about early warning signs, and built a list of trustworthy resources for patients.';

export const CAUSES_TITLE = 'Causes of Common Medical Conditions';
export const CAUSES_DESC =
  'Learn about risk factors and common causes of health conditions.' +
  ' Search medical conditions and chronic diseases from A to Z.';
export const CAUSES_CANONICAL = 'https://www.singlecare.com/conditions-causes';
export const CAUSES_TEXT_BELOW_SEARCH =
  'What causes hypertension? What does abdominal pain mean? Who is at risk for colon cancer?' +
  ' Why do I get recurrent UTIs? Knowing the root cause of symptoms helps treat medical ' +
  'conditions quickly and effectively. Use the following resource guides to learn more ' +
  'about the causes and risk factors of certain health conditions.';

export const CAUSES_TEXT_BELOW_LINKS =
  'As you browse the following guides, remember that only a healthcare provider can determine' +
  ' the underlying cause of your medical condition. It’s important to seek professional' +
  ' medical advice when you experience persistent or worsening symptoms. In these guides,' +
  ' we’ve listed common causes and risk factors for various medical conditions,' +
  ' answered frequently asked questions about when to seek medical attention,' +
  ' and compiled a list of authoritative resources for patients.';

export const CONDITIONS_CANONICAL =
  'https://www.singlecare.com/conditions-treatments';
export const CONDITIONS_DETAIL_CANONICAL =
  'https://www.singlecare.com/conditions/';
export const CONDITIONS_TEXT_BELOW_SEARCH =
  'From anxiety medication and dandruff shampoos to soothing a sore throat ' +
  'and preventing ear infections, each medical condition comes with its own ' +
  'treatment plan. These may include a combination of medications, therapies, ' +
  'surgeries, and home remedies like lifestyle or diet changes. ' +
  'Use the following resource guides to learn more about the common causes, ' +
  'symptoms, and treatments for specific health conditions.';

export const CONDITIONS_TEXT_BELOW_LINKS =
  'As you browse medications and treatments, ' +
  'it’s important to remember that only a healthcare professional can ' +
  'determine the best medication for you. A treatment plan depends on the ' +
  'individual patient, their symptoms, underlying health conditions, ' +
  'and tolerance for the medication side effects. In these guides, ' +
  'we’ve compared commonly prescribed medications for various medical conditions, ' +
  'answered frequently asked questions about cures and treatments, ' +
  'and curated a list of reliable resources for patients.';

export const CONDITIONS_DETAIL_TITLE =
  'Symptoms, Causes, ' + 'Medications and Treatments.';
export const CONDITIONS_DETAIL_DESC = 'Everything you need to know about ';
export const CONDITIONS_DETAIL_DESC_INCL =
  ' including symptoms, causes,' + ' medications and treatment options.';
export const BROWSE_PRESC_TITLE = 'Browse Top Prescriptions | SingleCare';
export const COLD_FLU_TITLE =
  'Coupons for Cold & Flu meds this Fall and Winter - SingleCare';
export const COLD_FLU_DESC =
  'Save up to 85% on your cold and flu medication at your local pharmacies this season. ' +
  'Compare prices on your essential Cold and Flu prescriptions.';
export const GENERIC_TITLE =
  'Singlecare - Prescription Coupons, Discounts and Prices';
export const GENERIC_DESC =
  'Save up to 80% on your prescriptions with the SingleCare card. ' +
  'Find the lowest price for your local pharmacy. Download your card today. No sign up and no fees.';
export const PHARMACISTS_TITLE =
  'SingleCare - Pharmacist Guide to Prescription Discounts';
export const PHARMACISTS_DESC =
  'Pharmacists use SingleCare’s prescription discount card to help their customers afford medication.' +
  'Download a card or request they are sent to your pharmacy.';
export const DRUG_DETAIL_TITLE = ': Uses, Warnings, Interactions & FAQs';
export const DRUG_DETAIL_DESC_PART1 = 'What it is used for, how to take';
export const DRUG_DETAIL_DESC_PART2 =
  ', serious side effects, ' +
  'food and drug interactions, forms, doses, safe storage, and FAQs.';
export const HOW_ITS_WORK_TITLE = 'How Does SingleCare Work?';
export const HOW_ITS_WORK_DESC =
  'SingleCare negotiates directly with pharmacies ' +
  'to save customers up to 80% on their medications. Our coupons are ' +
  'free and accepted at thousands of pharmacies.';
export const BASKET_TITLE = 'SingleCare Drug Basket';
export const BASKET_DESC =
  'Save all of your prescriptions in one place ' +
  'with our Drug Basket to streamline savings at a pharmacy near you.';
export const HELP_TITLE = 'SingleCare Customer Service & Help Desk';
export const HELP_DESC =
  'Need help using your SingleCare card? Find answers to ' +
  'frequently asked questions, call 844-234-3057, ' +
  "or chat online with customer service. We're available 24/7.";
export const SIGN_UP_TITLE = ' Sign Up for SingleCare';
export const SIGN_UP_DESC =
  'Did you know insurance copays can be more expensive ' +
  'than the cash price of a drug? Compare prices and save on thousands ' +
  'of prescriptions for free with SingleCare.';
export const BONUS_SAVING_TITLE = ' SingleCare Bonus Savings';
export const BONUS_SAVING_DESC =
  'Want to save more on meds? Sign up for free to' +
  ' earn more savings when you fill prescriptions using a SingleCare ' +
  'card and apply bonus savings to eligible meds.';
export const PRESC_DESC_CARD_TITLE =
  'Prescription Discount Card: Pharmacy Savings up to 80%';
export const PRESC_DESC_CARD_OG_DESC =
  'Download now to start saving up to 80% on your medications';
export const PRESC_DESC_URL =
  'https://www.singlecare.com/prescription-discount-card';
export const PRESC_DESC_URL_ES =
  'https://www.singlecare.com/es/tarjeta-de-descuento-para-medicamentos';
export const PRESC_DEL_TITLE =
  'Get prescriptions delivered with GeniusRx & SingleCare';
export const PRESC_DEL_TITLE_ES =
  'Recibe tus medicamentos a domicilio con GeniusRx y SingleCare';
export const PRESC_DEL_DESC =
  'Get prescriptions delivered directly to your doorstep with ' +
  'SingleCare and GeniusRx. Home delivery of medications has never' +
  ' been simpler or more reliable.';
export const PRESC_DEL_DESC_ES =
  'Recibe todos tus medicamentos en la comodidad de tu casa con el servicio de medicamentos a domicilio de GeniusRx y SingleCare.';
export const PRICE_LOOKUP_TITLE =
  'Compare Drug Prices: Prescription Price Lookup Tool | SingleCare';
export const PRICE_LOOKUP_DESC =
  'Compare drug prices at local pharmacies with our drug price lookup tool. ' +
  'SingleCare can help you find the lowest possible prescription prices at pharmacies near you.';
export const COMM_PREFERENCES_TITLE = 'Communication Preferences | SingleCare';
export const PHARMA_SOLUTIONS_TITLE = 'Pharmaceutical Solutions';
export const SOCIAL_DOMAIN = [
  'facebook.com',
  'instagram.com',
  'linkedin.com',
  'pinterest.com',
  'reddit.com',
  'snapchat.com',
  'tumblr.com',
  't.co',
  'twitter.com',
  'youtube.com',
  'quora.com',
  'tiktok.com',
  'x.com'
];
export const SEARCH_ENGINE = [
  'ask.com',
  'aol.com',
  'avg.com',
  'bing.com',
  'duckduckgo.com',
  'google.com',
  'msn.com',
  'yahoo.com',
  'ecosia.org',
  'dogpile.com',
  'yandex.ru',
  'naver.com',
  'qwant.com'
];

export const AI_SEARCH_ENGINE = [
  'chatgpt.com',
  'chat.openai.com',
  'perplexity.ai',
  'claude.ai',
  'gemini.google.com',
  'copilot.microsoft.com',
  'bard.google.com'
];

export const TRACKING_PARAMS = [
  'utm_campaign=',
  'utm_medium=',
  'utm_source=',
  'utm_term=',
  'utm_type=',
  'utm_content=',
  'utm_adgroup=',
  'matchtype=',
  'ct_Network=',
  'SiteTarget=',
  'source=',
  'subid1=',
  'subid2=',
  'subid3=',
  'ctid=',
  'gclid=',
  'creative=',
  'siteID=',
  'msclkid=',
  'pos=',
  'segments='
];

export const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const NAME_REGEX = /^[a-z\u00E0-\u00FC^U+E '-]{2,}$/i;
// export const PHONE_REGEX = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
export const KICKBOX_API = '/api/validate/';
export const CARD_TYPE_QUERY_PARAMETER = 'cardType';
export const CVS = 'CVS';
export const WALMART = 'Walmart';
export const WALGREENS = 'Walgreens';
export const SINGLECARE = 'SingleCare';
export const TARGET = 'Target';
export const HARRIS_TEETER = 'Harris Teeter';
export const RITE_AID = 'Rite Aid';
export const LONGS_DRUGS = 'Longs Drugs';
export const WALMART_MARKET = 'Walmart Neighborhood Market';
export const FRYS = "Fry's";
export const KROGER = 'Kroger';
export const ALBERTSONS = 'Albertsons';
export const SAV_ON = 'Sav-On';
export const CVS_PARTNER_PID = 'SingleCare CVS';
export const CVS_PARTNER_PASSWORD = '1B6AE476-B88B-4885-A388-407E2A260DB';
export const WALMART_PARTNER_PID = 'SingleCare Walmart';
export const WALMART_PARTNER_PASSWORD = 'A1B51AA9-2FA5-479A-99B9-94228CFB9BA';
export const WALGREENS_PARTNER_PID = 'SingleCare Walgreens';
export const WALGREENS_PARTNER_PASSWORD = '7s(@YSA;R@`YV26XDnvc$';
export const WALMART_MARKET_PID = 'SingleCare WMNHM';
export const WALMART_MARKET_PASSWORD = 'TzRF3qet8spMhEq';
export const PHARMACIST_DEFAULT_PARTNER_PID = 'PharmacistLMTD';
export const PHARMACIST_DEFAULT_PARTNER_PWD = '7xSe+-8uL8';
export const PHARMACIST_WALMART_PARTNER_PID = 'PharmacistWMT';
export const PHARMACIST_WALMART_PARTNER_PWD = "9(Kq,2S`e$f(Rn'S";
export const PHARMACIST_CVS_PARTNER_PID = 'PharmacistCVS';
export const PHARMACIST_CVS_PARTNER_PWD = 'pM^MBh}e<:%22)Jv';
export const FLORENCE_HEALTH_PID = 'Florence Health';
export const FLORENCE_HEALTH_PWD = 'suVed7*uT7sl4ec_f8oz';
export const WALMART_PBA_CLIENT_NAME = 'Walmart';
export const WALMART_PBA_CLIENT_ID = 2;
export const CVS_PBA_CLIENT_ID = 4;
export const GENIUS_PBA_CLIENT_ID = 9;
export const WALMART_PHARMACY_DESCRIPTION_1 =
  'Walmart card valid only at Walmart pharmacies.';
export const CVS_PHARMACY_DESCRIPTION_1 =
  'CVS card valid only at CVS pharmacies.';
export const WALMART_PHARMACY_DESCRIPTION_2 =
  'Prices for some drugs may be higher or vary in some states including, but not necessarily limited to, CA and MN.';
export const COOKIES_ZIPCODE = 'zipCode';
export const COOKIES_USER_LOCATION = 'userLatLng';

// ALL CONTACT TYPE ID'S
export const RX_CARD_VIEW = 93;
export const RX_CARD_SMS = 76;
export const RX_CARD_MAIL = 77;
export const PRESC_CARD_SMS = 5;
export const PRESC_CARD_MAIL = 13;
export const RXSAVING_VIEW = 77;
export const RXSAVING_DOWNLOAD = 1;
export const RX_APP_PROMO = 125;
export const RXSAVING_PARTNER_PID =
  'rxsavings-44b786dab34f4957aeb6477ecb53fdc2';
export const RXSAVING_PARTNER_PASSWORD = 'z!7bHW@eS6';
export const ONLY_NUMBER_REGEX = /^[0-9]+$/;
export const HOME_POST_COUNT = 4;
export const PRESC_BLOG_COUNT = 9;
export const DEFAULT_EMPTY_BASKET = {
  drugBasketId: null,
  pricing: []
};
export const pharmacyName = [
  { id: 0, name: 'CVS' },
  { id: 1, name: 'Walmart' },
  { id: 2, name: 'Other' }
];
export const pharmacyList = [
  { id: 0, name: 'CVS' },
  { id: 1, name: 'Walgreens' },
  { id: 2, name: 'Walmart' },
  { id: 3, name: 'Other' }
];

export const STATE_LIST = [
  { value: '', name: 'Select' },
  { value: 'AL', name: 'Alabama' },
  { value: 'AK', name: 'Alaska' },
  { value: 'AZ', name: 'Arizona' },
  { value: 'AR', name: 'Arkansas' },
  { value: 'CA', name: 'California' },
  { value: 'CO', name: 'Colorado' },
  { value: 'CT', name: 'Connecticut' },
  { value: 'DC', name: 'District of Columbia' },
  { value: 'DE', name: 'Delaware' },
  { value: 'FL', name: 'Florida' },
  { value: 'GA', name: 'Georgia' },
  { value: 'HI', name: 'Hawaii' },
  { value: 'ID', name: 'Idaho' },
  { value: 'IL', name: 'Illinois' },
  { value: 'IN', name: 'Indiana' },
  { value: 'IA', name: 'Iowa' },
  { value: 'KS', name: 'Kansas' },
  { value: 'KY', name: 'Kentucky' },
  { value: 'LA', name: 'Louisiana' },
  { value: 'ME', name: 'Maine' },
  { value: 'MD', name: 'Maryland' },
  { value: 'MA', name: 'Massachusetts' },
  { value: 'MI', name: 'Michigan' },
  { value: 'MN', name: 'Minnesota' },
  { value: 'MS', name: 'Mississippi' },
  { value: 'MO', name: 'Missouri' },
  { value: 'MT', name: 'Montana' },
  { value: 'NE', name: 'Nebraska' },
  { value: 'NV', name: 'Nevada' },
  { value: 'NH', name: 'New Hampshire' },
  { value: 'NJ', name: 'New Jersey' },
  { value: 'NM', name: 'New Mexico' },
  { value: 'NY', name: 'New York' },
  { value: 'NC', name: 'North Carolina' },
  { value: 'ND', name: 'North Dakota' },
  { value: 'OH', name: 'Ohio' },
  { value: 'OK', name: 'Oklahoma' },
  { value: 'OR', name: 'Oregon' },
  { value: 'PA', name: 'Pennsylvania' },
  { value: 'PR', name: 'Puerto Rico' },
  { value: 'RI', name: 'Rhode Island' },
  { value: 'SC', name: 'South Carolina' },
  { value: 'SD', name: 'South Dakota' },
  { value: 'TN', name: 'Tennessee' },
  { value: 'TX', name: 'Texas' },
  { value: 'UT', name: 'Utah' },
  { value: 'VT', name: 'Vermont' },
  { value: 'VA', name: 'Virginia' },
  { value: 'WA', name: 'Washington' },
  { value: 'WV', name: 'West Virginia' },
  { value: 'WI', name: 'Wisconsin' },
  { value: 'WY', name: 'Wyoming' }
];

export const COLD_FLU_DRUGS = [
  {
    type: 'standard dose',
    name: 'Fluzone Quadrivalent',
    srcSet: 'logo-color-cvs.svg',
    discountPrice: 31.0,
    url: '/prescription/fluzone-quadrivalent?q=Fluzone Quadrivalent'
  },
  {
    type: 'high dose',
    name: 'Fluzone Quadrivalent',
    srcSet: 'logo-color-cvs.svg',
    discountPrice: 69.92,
    url: '/prescription/fluzone-high-dose-quadrivalent?q=Fluzone High-Dose Quadrivalent'
  },
  {
    type: 'antiviral',
    name: 'Oseltamivir Phosphate',
    srcSet: 'logo-color-cvs.svg',
    discountPrice: 39.74,
    url: '/prescription/oseltamivir-phosphate?q=Oseltamivir Phosphate (Tamiflu)'
  }
];
export const LEMONAID_DRUGS = [];

export const PERSIST_BASKET = false;

// export const MOBILE_REGEX = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const TENANT_ID = 0;

export const STATIC_DIV_LIMIT = 8;

export const FORMS = [
  'Capsule',
  'Cápsula',
  'Capsule Delayed Release',
  'Cápsula De Liberación Retardada',
  'Capsule Delayed Release Particles',
  'Cápsula Con Partículas De Liberación Retardada',
  'Capsule Delayed Release Sprinkle',
  'Cápsula Con Medicamento En Polvo De Liberación Retardada',
  'Capsule Er 12 Hour Abuse-Deterrent',
  'Cápsula De Liberación Prolongada De 12 Horas, Disuasivo De Abuso',
  'Capsule Er 24 Hour Sprinkle',
  'Cápsulas De Liberación Prolongada De 24 Horas Con Medicamento En Polvo',
  'Capsule Extended Release',
  'Cápsula De Liberación Prolongada',
  'Capsule Extended Release 12 Hour',
  'Cápsula De Liberación Prolongada De 12 Horas',
  'Capsule Extended Release 24 Hour',
  'Cápsula De Liberación Prolongada De 24 Horas',
  'Capsule Sprinkle',
  'Cápsula Con Medicamento En Polvo',
  'Tablet',
  'Tableta',
  'Tablet Abuse-Deterrent',
  'Tableta Disuasiva Del Abuso De Sustancias',
  'Tablet Chewable',
  'Tableta Masticable',
  'Tablet Chewable Extended Release',
  'Tableta Masticable De Liberación Prolongada',
  'Tablet Delayed Release',
  'Tableta De Liberación Retardada',
  'Tablet Disintegrating',
  'Tableta Desintegrante',
  'Tablet Disintegrating Soluble',
  'Tableta Desintegrante Soluble',
  'Tablet Effervescent',
  'Tableta Efervescente',
  'Tablet Er 12 Hour Abuse-Deterrent',
  'Tableta De Liberación Prolongada De 12 Horas, Disuasiva De Abuso',
  'Tablet Er 24 Hour Abuse-Deterrent',
  'Tableta De Liberación Prolongada De 24 Horas, Disuasiva De Abuso',
  'Tablet Extended Release',
  'Tableta De Liberación Prolongada',
  'Tablet Extended Release 12 Hour',
  'Tableta De Liberación Prolongada De 12 Horas',
  'Tablet Extended Release 24 Hour',
  'Tableta De Liberación Prolongada De 24 Horas',
  'Tablet Extended Release Abuse-Deterrent',
  'Tableta De Liberación Prolongada, Disuasiva De Abuso',
  'Tablet Extended Release Disintegrating',
  'Tableta Desintegrante De Liberación Prolongada',
  'Tablet Soluble',
  'Tableta Soluble',
  'Tablet Sublingual',
  'Tableta Sublingual'
];

export const UPDATE_REASON = [
  {
    value: 'My information has changed',
    label: 'My information has changed'
  },
  {
    value: 'My information is entered incorrectly',
    label: 'My information is entered incorrectly'
  },
  {
    value: 'My information is incomplete',
    label: 'My information is incomplete'
  },
  { value: 'Other', label: 'Other' }
];

export const UPDATE_REASON_ES = [
  {
    value: 'My information has changed',
    label: 'Mi información ha cambiado'
  },
  {
    value: 'My information is entered incorrectly',
    label: 'Mi información está capturada incorrectamente'
  },
  {
    value: 'My information is incomplete',
    label: 'Mi información está incompleta'
  },
  { value: 'Other', label: 'Otra' }
];

export const SIGNUP_STATE = {
  FName: '',
  LName: '',
  Email: '',
  FNameErr: '',
  LNameErr: '',
  EmailErr: '',
  birthDate: '',
  birthDateErr: '',
  emailKickboxErr: false
};

export const DEFAULT_PASSWORD_STATE = {
  password: '',
  passwordErr: '',
  confirmPassword: '',
  confirmPasswordErr: '',
  eightChar: false,
  lowerCaseLetter: false,
  oneNumber: false,
  capitalLetter: false,
  passwordMatch: false,
  hideCurrentPassword: true,
  hideNewPassword: true,
  hideConfirmPassword: true,
  apiCommonValidationError: false
};

export const GOOGLE_SITE_KEY = '6LeAt7MZAAAAAAtk4UWjyGqQYyJ99RXMlY9epglD';

export const APP_URL = {
  ONE_LINK_URL: 'https://singlecare.onelink.me/OxIQ/c8fe6bf',
  ONE_LINK_APP_STORE: 'https://singlecare.onelink.me/OxIQ/c66c05bb',
  ONE_LINK_PLAY_STORE:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_apppage&c=web_apppage_app-promo_mobile&af_channel=Web_App-Promotion&af_dp=singlecareapp%3A%2F%2F',
  HOME_IOS_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_homepage&c=web_homepage_app-promo_ios&af_web_dp=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fsinglecare%2Fid988894598&af_channel=Web_App-Promotion',
  HOME_ANDROID_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_homepage&c=web_homepage_app-promo_android&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.singlecare.scma%26hl%3Den_US&af_channel=Web_App-Promotion',
  HOME_MOBILE_LINK: 'https://singlecare.onelink.me/OxIQ/13c5743c',
  DRUG_MOBILE_LINK: 'https://singlecare.onelink.me/OxIQ/5b107f24',
  FOOTER_MOBILE_LINK: 'https://singlecare.onelink.me/OxIQ/9c6baf27',
  OTHER_MOBILE_LINK: 'https://singlecare.onelink.me/OxIQ/e25d1102',
  OTHER_ONE_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_other&c=web_other_app-promo&af_channel=Web_App-Promotion&af_dp=singlecareapp%3A%2F%2F',
  OTHER_IOS_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_other&c=web_other_app-promo_ios&af_web_dp=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fsinglecare%2Fid988894598&af_channel=Web_App-Promotion',
  OTHER_ANDROID_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_other&c=web_other_app-promo_android&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.singlecare.scma%26hl%3Den_US&af_channel=Web_App-Promotion',
  DRUG_IOS_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_drugpage&c=web_drugpage_app-promo_mobile_iOS&af_web_dp=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fsinglecare%2Fid988894598&af_channel=Web_App-Promotion&af_dp=singlecareapp%3A%2F%2F',
  DRUG_ANDROID_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_drugpage&c=web_drugpage_app-promo_mobile_android&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.singlecare.scma%26hl%3Den_US&af_channel=Web_App-Promotion&af_dp=singlecareapp%3A%2F%2F',
  FOOTER_IOS_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_footer&c=web_footer_app-promo_ios&af_web_dp=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fsinglecare%2Fid988894598&af_channel=Web_App-Promotion',
  FOOTER_ANDROID_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_footer&c=web_footer_app-promo_android&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.singlecare.scma%26hl%3Den_US&af_channel=Web_App-Promotion',
  APP_PAGE_IOS_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_apppage&c=web_apppage_app-promo_mobile_iOS&af_web_dp=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fsinglecare%2Fid988894598&af_channel=Web_App-Promotion&af_dp=singlecareapp%3A%2F%2F',
  APP_PAGE_ANDROID_LINK:
    'https://singlecare.onelink.me/OxIQ?pid=sc_website_apppage&c=web_apppage_app-promo_mobile_android&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.singlecare.scma%26hl%3Den_US&af_channel=Web_App-Promotion&af_dp=singlecareapp%3A%2F%2F'
};
export const FLORENCE_HEALTH_TITLE =
  'SingleCare Prescription Discount Card: Pharmacy Savings Up to 80%';
export const FLORENCE_HEALTH_CANONICAL =
  'https://www.singlecare.com/lp/florence-health';
export const FLORENCE_HEALTH_OG_TITLE =
  'Save Up to 80% on Prescriptions with a SingleCare Discount Card';
export const FLORENCE_HEALTH_OG_DESC =
  'Florence Health is partnering with SingleCare to offer healthcare professionals savings up to 80% off prescription medications.';
export const FLORENCE_HEALTH_DESC =
  'Healthcare professionals need pharmacy savings too! Florence Health readers can use SingleCare coupons to save up to 80% on prescriptions';
export const DEFAULT_ERR = 'Something went wrong. Please try again later.';
export const SPECIAL_DRUG_ERR = 'This drug was not added to basket.';
export const SPECIAL_DRUG_ERR_ES =
  'Este medicamento no se agregó a la canasta.';
export const INTELLIMIZE_GENIUS_SIGN_UP_EVENT = 'geniusRxSignUpSubmission';
export const INTELLIMIZE_LOYALTY_SIGN_UP_EVENT = 'loyaltySignUpSubmission';
export const INTELLIMIZE_LOYALTY_SIGN_UP_STARTED = 'SignUpStarted';
export const INTELLIMIZE_TEXT_APP_DOWNLOAD_LINK_SUCCESS =
  'text_app_download_link_success';
export const INTELLIMIZE_POPULAR_DRUG_CLICK = 'PopularDrugClick';
export const INTELLIMIZE_HOMEPAGE_SEARCHBAR_CLICK = 'HomepageSearchbarClick';
export const INTELLIMIZE_HOW_IT_WORKS_CLICK = 'HowItWorksClick';
export const INTELLIMIZE_SEARCH_MENU_DRUG_CLICK = 'SearchMenuDrugClick';
export const PRIVACY_POLICY_ES_TITLE = 'Políticas de privacidad | SingleCare';
export const PRIVACY_POLICY_ES_DESC =
  'Conoce las políticas de privacidad de SingleCare.' +
  'Tu información siempre está protegida con nuestro servicio de tarjetas de descuento para medicamentos.';
export const HELP_TITLE_ES =
  'Servicio al cliente y preguntas frecuentes | SingleCare';
export const HELP_DESC_ES =
  'Te presentamos las respuestas a las preguntas más ' +
  'frecuentes sobre nuestros descuentos en farmacias para brindarte toda la ' +
  'confianza que necesitas.';
export const HOME_TITLE_ES =
  'Consigue descuentos en medicamentos de receta | SingleCare';
export const HOME_DESC_ES =
  'Utilizando SingleCare podrás obtener increíbles descuentos en medicamentos' +
  ' de hasta el 80% en miles de farmacias de todo el país.';
export const ABOUT_US_TITLE_ES = 'Sobre nosotros | SingleCare';
export const ABOUT_US_DESC_ES =
  'Conoce SingleCare y ahorra mucho dinero con ' +
  'nuestras tarjetas de descuento para medicamentos válidas en más de ' +
  '35,000 farmacias de todo el país.';
export const BROWSE_PRESC_TITLE_ES = 'Buscar medicamentos | SingleCare';
export const BROWSE_PRESC_DESC_ES =
  'Con ayuda de SingleCare puedes buscar tus ' +
  'medicamentos y encontrar los precios más bajos en más de 35,000 ' +
  'farmacias asociadas de todo el país.';
export const BROWSE_PRESC_DESC_EN =
  'Save up to 80% off Rx medications by using a SingleCare prescription ' +
  'discount card at local pharmacies. ' +
  'Our savings coupons are updated daily.';
export const BROWSE_PRESC_SUB_DESC_EN =
  'Save up to 80% off Rx medications starting with';
export const HOW_ITS_WORK_TITLE_ES =
  'Cómo funcionan los descuentos ' + 'en medicamentos | SingleCare';
export const HOW_ITS_WORK_DESC_ES =
  'Descubre cómo funciona el sistema de ' +
  'SingleCare para descuentos en medicamentos y todos los beneficios ' +
  'adicionales que tenemos para ti.';
export const SIGN_UP_TITLE_ES = 'Registrarse | SingleCare';
export const SIGN_UP_DESC_ES =
  'Regístrate de manera gratuita en SingleCare para obtener descuentos en ' +
  'medicamentos adicionales y muchos otros beneficios';
export const BONUS_SAVING_TITLE_ES =
  'Bonificaciones de ahorro de SingleCare | SingleCare';
export const BONUS_SAVING_DESC_ES =
  'Descubre cómo maximizar tus ahorros en la compra de medicinas con las bonificaciones de ahorro que otorga ' +
  'SingleCare a los miembros de su programa.';
export const TERMS_TITLE_ES =
  'Términos y Condiciones de nuestros Servicios | SingleCare';
export const TERMS_DESC_ES =
  'Conoce los términos y condiciones para tener acceso a los beneficios del Programa de descuentos para medicamentos de SingleCare.';
export const BASKET_TITLE_ES = 'Canasta de medicamentos | SingleCare';
export const BASKET_DESC_ES =
  'Agrega todo lo que necesitas en tu canasta de ' +
  'medicamentos y encuentra los precios más bajos en la farmacia más cercana.';
export const MEMBER_CENTER_TITLE = 'Member center | SingleCare';
export const MEMBER_CENTER_DESC =
  'Monitor the activity of your bonuses and ' +
  'savings on all your medications by being a member of SingleCare.';
export const MEMBER_CENTER_TITLE_ES = 'Centro para miembros | SingleCare';
export const MEMBER_CENTER_DESC_ES =
  'Monitorea la actividad de tus ' +
  'bonificaciones y ahorros en todos tus medicamentos al formar parte ' +
  'de los miembros de SingleCare.';
export const ACCOUNT_INFO_TITLE = 'Account setting | SingleCare';
export const ACCOUNT_INFO_DESC =
  'Access the SingleCare account settings. ' +
  'Modify your information and update the data of your user profile.';
export const ACCOUNT_INFO_TITLE_ES = 'Configuración de cuenta | SingleCare';
export const ACCOUNT_INFO_DESC_ES =
  'Accede a la configuración de cuenta ' +
  'SingleCare. Modifica tu información y actualiza los datos ' +
  'de tu perfil de usuario.';
export const POLICY_TITLE_ES = 'Políticas de privacidad | SingleCare';
export const POLICY_DESC_ES =
  'Conoce las políticas de privacidad de SingleCare.' +
  ' Tu información siempre está protegida con nuestro servicio de ' +
  'tarjetas de descuento para medicamentos.';
export const PRESCRIPTION_TITLE_PART1_ES = 'Cupón para';
export const PRESCRIPTION_TITLE_PART2_ES = year + ' - Hasta 80% de descuento';
export const PRESCRIPTION_DESC_FIND_ES = 'Encuentra el mejor cupón para ';
export const PRESCRIPTION_DESC_SAVE_ES =
  ' y ahorra hasta un 80% de descuento en ';
export const PRESCRIPTION_DESC_INCLUDING_ES =
  ' incluyendo medicamentos genéricos. ' +
  'También puedes encontrar ofertas de cupones del fabricante y recibir ' +
  'una tarjeta de ahorro de farmacia para obtener un descuento inmediato en ' +
  'farmacias como CVS, Walgreens, Walmart y más.';
export const NAVITUS = 'NVT';
export const RXSENSE = 'RXS';
export const SC_APP_TITLE = 'SingleCare App for Prescriptions - Up to 80% Off!';
export const SC_APP_DESC =
  'Download the SingleCare app to compare drug prices and get free pharmacy coupons ' +
  'for your next Rx. Our prescription discount app is free for iOS and Android.';
export const SC_APP_TITLE_ES =
  'SingleCare App for Prescriptions - Up to 80% Off!';
export const SC_APP_DESC_ES =
  'Download the SingleCare app to compare drug prices and get free pharmacy coupons ' +
  'for your next Rx. Our prescription discount app is free for iOS and Android.';
export const SC_APP_KEYWORDS =
  'SingleCare app (10K monthly searches), prescription ' +
  'discount app (250), SingleCare app for prescriptions (10)';
export const SC_APP_KEYWORDS_ES =
  'SingleCare app (10K monthly searches), prescription ' +
  'discount app (250), SingleCare app for prescriptions (10)';
export const SAVE_DRUG_TITLE = 'Saved drug coupons | SingleCare';
export const SAVE_DRUG_DESC = `Have multiple refills? Search for your prescription on SingleCare and click "save" to save your medications and find drug coupons easier for your next refill.`;
export const GLP_TITLE = 'GLP-1 Drugs & Medication Coupons';
export const GLP_DESC =
  'Get discounts on GLP-1 meds like semaglutide (Ozempic, Wegovy, Rybelsus) and tirzepatide (Mounjaro, Zepbound) for weight loss and diabetes treatment.';

export const HOME_DELIVERY_PHARMA_LIST = [
  'CVS',
  'Walmart',
  'Walgreens',
  'Other'
];

export const HOME_DELIVERY_IMAGES = [
  {
    src: 'cvs',
    className: 'cvs',
    width: '210'
  },
  {
    src: 'walmart',
    className: 'walmart',
    width: '190'
  },
  {
    src: 'walgreens',
    className: 'walgreens',
    width: '190'
  },
  {
    src: 'albertsons',
    className: 'albertsons',
    width: '100'
  },
  {
    src: 'kroger',
    className: 'kroger',
    width: '140'
  },
  {
    src: 'harris-teeter',
    className: 'harristeeter',
    width: '190'
  },
  {
    src: 'heb',
    className: 'heb',
    width: '160'
  },
  {
    src: 'vee',
    className: 'vee',
    width: '160'
  },
  {
    src: 'rite-aid',
    className: 'Rite aid',
    width: '190'
  }
];

export const INTELLIMIZE_UPDATE_DOSAGE_EVENT = {
  BRAND_SELECT: 'select-drug-brand',
  FORM_SELECT: 'select-drug-form',
  DOSAGE_SELECT: 'select-drug-dosage',
  QUANTITY_SELECT: 'select-drug-quantity',
  SUBMIT_DOSAGE: 'submit-drug-details'
};

export const INTELLIMIZE_COUPON_EVENT = {
  GENERATE_COUPON: 'coupon-generated',
  COUPON_EMAIL_SENT: 'coupon-email-send',
  COUPON_TEXT_SENT: 'coupon-text-send',
  PRESCRIPTION_COUPON_GENERATE: 'prescriptionCouponGenerated',
  PRINT_COUPON_GENERATED: 'printCouponGenerated',
  COUPON_MODAL_SAVE_COUPON: 'couponModalSaveCoupon',
  GENERATE_CARD: 'cardGenerated',
  COUPON_EMAIL_BUTTON_CLICK: 'coupon-email-button-click',
  COUPON_TEXT_BUTTON_CLICK: 'coupon-text-button-click',
  COUPON_ADDEDTOWALLET: 'coupon-addedToWallet',
  COUPON_EXPANDED: 'coupon-expanded'
};

export const PUBLIC_ROUTE_REGEX =
  /forgot-password|es\/restablecer-contrasena|change-password|es\/cambiar-contrasena|signup|sign-up|es\/registrarse/;

export const HEADER_SEARCH_REGEX =
  /browse-prescriptions|tvcampaign|buscar-medicamentos|prescription-delivery|medicamentos-a-domicilio|familywize|comp|drug-price-look-up-tool|medicare/;

export const MILE = [
  {
    value: 0.99,
    label: '< 1 mile'
  },
  {
    value: 1,
    label: '1 mile'
  },
  {
    value: 2,
    label: '2 miles'
  },
  {
    value: 5,
    label: '5 miles'
  },
  {
    value: 10,
    label: '10 miles'
  },
  {
    value: 25,
    label: '25 miles'
  }
];

export const DEFAULT_MILE = MILE[4];

export const OPEN_NOW_VALUE = 'openNow';
export const HAS_24_HRS_VALUE = 'has_open_24_hrs';
export const HAS_DRIVE_THROUGH = 'has_drive_through';
export const HAS_DELIVERY = 'has_delivery';
export const HAS_CURBSIDE = 'has_curbside_pickup';

export const PHARMACY_FILTER = [
  {
    value: OPEN_NOW_VALUE,
    label: 'Open now',
    isSelected: false
  },
  {
    value: HAS_24_HRS_VALUE,
    label: '24 hour',
    isSelected: false
  },
  {
    value: HAS_DRIVE_THROUGH,
    label: 'Drive-thru',
    isSelected: false
  },
  {
    value: HAS_DELIVERY,
    label: 'Delivery',
    isSelected: false
  },
  {
    value: HAS_CURBSIDE,
    label: 'Curbside pickup',
    isSelected: false
  }
];

export const PHARMA_DIRECTORY_INITIAL_FILTER = {
  pharmacyBrand: '',
  distance: DEFAULT_MILE.value,
  filters: {
    openNow: false,
    serviceOptions: []
  }
};

export const DEFAULT_MAP_PROPS = {
  center: {
    lat: 37.7711016,
    lng: -100.3633856
  },
  zoom: 4
};

export const PHARMACY_STATE_URL = 'pharmacies-state/';
export const PHARMACIES_URL = 'pharmacies/';

export const PARTNERS_TITLE_EN = 'SingleCare Partnerships';
export const PARTNERS_DESC_EN =
  'SingleCare partners with nonprofit organizations to help communities access affordable prescription drugs, ensuring greater health and financial stability.';
export const PARTNERS_TITLE_ES = 'Asociaciones de SingleCare';
export const PARTNERS_DESC_ES =
  'SingleCare se asocia con organizaciones sin fines de lucro para ayudar a las comunidades a obtener medicamentos recetados económicos, lo que garantiza una mayor salud y estabilidad financiera.';
export const OUTLINE_CSS_CLASS = 'inputoutline';

export const FREE_COUPON_MODAL = 'freeCouponModal';
export const LOYALTY_SIGNUP_MODAL = 'loyaltySignupModal';
export const NAVBAR_SIGNUP_MODAL = 'narBarSignupModal';
export const HOMEPAGE_MID_SIGNUP_MODAL = 'homepageMidSignupModal';
export const GLP_SIGNUP_MODAL = 'glpPageSignupModal';
export const DRUG_RESOURCE_SIGNUP_MODAL = 'DrugResourceSignupModal';
export const SIGNUP_PAGE_SIGNUP_MODAL = 'signupPageSignupModal';
export const COUPON_TEXT_SEND_SIGNUP_MODAL = 'couponTextSentSignupModal';
export const COUPON_EMAIL_SEND_SIGNUP_MODAL = 'couponEmailSentSignupModal';
export const PHARMACY_PRICE_LIST_MODAL = 'pharmacyPriceListModal';
export const SOFT_COUPON_MODAL = 'softCouponModal';
export const HAMBURGER_MENU_MODAL = 'hamburgerMenuModal';
export const MENU_TYPE_LINK = 'link';
export const MENU_TYPE_FUNCTION = 'function';
export const MENU_CHECK_LANG = 'lang';
export const MENU_CHECK_PATH = 'path';
export const MENU_CHECK_API = 'api';
export const MENU_CHECK_ALLOW_HOME_DELIVERY = 'HomeDelivery';
export const MENU_CHECK_USER = 'user';
export const MENU_CHECK_USER_LOG_OUT = 'userLogout';
export const GTM_PHYSICAL_CARD_CTA_CLICK = 'physicalCardCTAclick';
export const GTM_PHYSICAL_CARD_MODAL_OPEN = 'physicalCardModalOpen';
export const GTM_PHYSICAL_CARD_SUCCESS = 'physicalCardSendSuccess';
export const GTM_PHYSICAL_CARD_MODAL_NEWS_LETTER_CHECK =
  'physicalCardModalNewsletterCheck';
export const GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_CLICK =
  'physicalCardConfirmationTextClick';
export const GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_SEND_SUCCESS =
  'physicalCardConfirmationTextSendSuccess';
export const GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_CLICK =
  'physicalCardConfirmationEmailClick';
export const GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_SEND_SUCCESS =
  'physicalCardConfirmationEmailSendSuccess';
export const GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CLICK =
  'physicalCardConfirmationPrintClick';
export const GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CARD_GENERATED =
  'physicalCardConfirmationPrintCardGenerated';
export const GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_APP_SUCCESS =
  'physicalCardConfirmationTextAppSuccess';
export const GTM_APP_DOWNLOAD_CTA_MOBILE_CLICK =
  'app_download_cta_mobile_click';
export const GTM_APP_STORE_BADGE_CTA_CLICK = 'app_store_badge_cta_click';
export const GTM_TEXT_APP_DOWNLOAD_LINK_SUCCESS =
  'text_app_download_link_success';
export const GTM_PHYSICAL_CARD_CARD_SEND_ERROR = 'physicalCardSendError';
export const LEGIT_SCRIPT = `<script src="https://static.legitscript.com/seals/1013987.js" type="text/javascript" class="optanon-category-C0001"></script>`;

const CTA_PREFIX = 'https://singlecare.onelink.me/OxIQ/';

export const DRUG_CLASS_CTA = {
  MWEB: CTA_PREFIX + 'b0dh1p4x',
  PLAY_STORE: CTA_PREFIX + 'zfm0ji13',
  APP_STORE: CTA_PREFIX + '99fg6vly',
  QR_CODE: 'ep5vw6n9'
};
export const DRUG_DOSAGE_CTA = {
  MWEB: CTA_PREFIX + 'iux6ksyq',
  PLAY_STORE: CTA_PREFIX + 'hwco8bkm',
  APP_STORE: CTA_PREFIX + '2sppsnas',
  QR_CODE: 'hme9ufph'
};
export const CONDITIONS_CTA = {
  MWEB: CTA_PREFIX + 'a4btmbca',
  PLAY_STORE: CTA_PREFIX + 'bgaz5v8w',
  APP_STORE: CTA_PREFIX + 'i1gxd61w ',
  QR_CODE: 'viajog08'
};
export const WHAT_IS_CTA = {
  MWEB: CTA_PREFIX + 'arm5ch28',
  PLAY_STORE: CTA_PREFIX + 'v2n621xa',
  APP_STORE: CTA_PREFIX + '3s6n80l0',
  QR_CODE: 'rutjlj7t'
};
export const PHARMACY_CTA = {
  MWEB: CTA_PREFIX + '4bu20w84',
  PLAY_STORE: CTA_PREFIX + 'j59wt8wu',
  APP_STORE: CTA_PREFIX + '7vj6msjg',
  QR_CODE: 'mizxnol6'
};

export const HOME_DRUGS_DATA = [
  {
    name: 'Amlodipine Besylate',
    url: 'amlodipine-besylate',
    discounted_price: '9.78',
    dosage: '30 tablets, 5mg',
    average_price: '32.10',
    discount: '70'
  },
  {
    name: 'Prednisone',
    url: 'prednisone',
    discounted_price: '5.86',
    dosage: '10 tablets, 20mg',
    average_price: '11.93',
    discount: '51'
  },
  {
    name: 'Amoxicillin',
    url: 'amoxicillin',
    discounted_price: '9.20',
    dosage: '21 capsule, 500mg',
    average_price: '12.82',
    discount: '28'
  },
  {
    name: 'Atorvastatin Calcium',
    url: 'atorvastatin-calcium',
    discounted_price: '24.66',
    dosage: '30 tablets, 40mg',
    average_price: '87.11',
    discount: '72'
  },
  {
    name: 'Fluoxetine Hcl',
    url: 'fluoxetine-hcl',
    discounted_price: '14.35',
    dosage: '30 capsule, 20mg',
    average_price: '25.10',
    discount: '43'
  },
  {
    name: 'Finasteride',
    url: 'finasteride',
    discounted_price: '28.88',
    dosage: '30 tablet, 1mg',
    average_price: '66.72',
    discount: '57'
  },
  {
    name: 'Losartan Potassium',
    url: 'losartan-potassium',
    discounted_price: '12.05',
    dosage: '30 tablet, 50mg',
    average_price: '51.42',
    discount: '77'
  },
  {
    name: 'Omeprazole',
    url: 'omeprazole',
    discounted_price: '23.17',
    dosage: '30 Capsule, 20mg',
    average_price: '53.11',
    discount: '56'
  },
  {
    name: 'Azithromycin',
    url: 'azithromycin',
    discounted_price: '17.83',
    dosage: '1 Box, 6 tablets',
    average_price: '33.70',
    discount: '47'
  },
  {
    name: 'Levothyroxine Sodium',
    url: 'levothyroxine-sodium',
    discounted_price: '5.38',
    dosage: '50 mcg, 30 Count',
    average_price: '22.97',
    discount: '77'
  }
];
export const BONUS_PRICE = 3;
export const REFERRAL_BONUS_PRICE = 5;

export const HIDE_LOYALTY_MODAL_PHARMA_LIST = [
  'Acme Pharmacy',
  'Albertsons Market Pharmacy',
  'Market Street Pharmacy',
  'Osco Pharmacy',
  'Randalls Pharmacy',
  'Savon Pharmacy',
  'Safeway Pharmacy',
  'Tom Thumb Pharmacy',
  'United Pharmacy',
  'Vons Pharmacy',
  'Family Fare Pharmacy',
  'Martins',
  'Winn Dixie',
  'Big Y Pharmacy',
  'Brookshires Pharmacy',
  'Super 1 Foods',
  'Fairview',
  'Food City Pharmacy',
  'Giant Eagle Pharmacy',
  'Heb Pharmacy',
  'Hy-Vee Pharmacy',
  'Meijer Pharmacy',
  'Publix',
  'Food Lion',
  'Giant',
  'Giant Eagle Pharmacy',
  'Giant Food',
  'Hannaford',
  'Martins',
  'Martins Pharmacy',
  'Stop & Shop',
  'Discount Drug Mart',
  'Price Chopper',
  'Raleys',
  'Weis',
  'Harveys Supermarket',
  'Fresco Y Mas',
  'Vgs Pharmacy',
  'Family Fresh Market Pharmacy',
  'Econofoods Pharmacy',
  'dw pharmacy',
  'Family Fare - Forest Hills Pharmacy',
  'Albertsons Pharmacy',
  'Amigos Pharmacy',
  'Carrs Pharmacy',
  'Haggen Pharmacy',
  'Pavilions Pharmacy'
];

export const MOBILE_VIEW_PORT = 767;
export const DESKTOP_VIEW_PORT = 1024;
export const IPAD_PRO_LANDSCAPE_VIEW_PORT = 1366;
export const IPAD_AIR_LANDSCAPE_VIEW_PORT = 1180;
export const IPAD_AIR_VIEW_PORT = 820;

export const POPULAR_DRUGS = [
  {
    name: 'Amoxicillin',
    seoName: 'amoxicillin'
  },
  {
    name: 'Methylprednisolone',
    seoName: 'methylprednisolone'
  },
  {
    name: 'Sildenafil',
    seoName: 'sildenafil-citrate'
  },
  {
    name: 'Fluconazole',
    seoName: 'fluconazole'
  },
  {
    name: 'Zithromax',
    seoName: 'zithromax'
  },
  {
    name: 'Amlodipine Besylate',
    seoName: 'amlodipine-besylate'
  },
  {
    name: 'Cyanocobalamin',
    seoName: 'cyanocobalamin'
  },
  {
    name: 'Prednisone',
    seoName: 'prednisone'
  },
  {
    name: 'Atorvastatin-hcl',
    seoName: 'atorvastatin-calcium'
  }
];
export const IDLETIMER = {
  DEFAULT_TIMEOUT: 1000 * 60 * 15,
  DEFAULT_PROMPT_BEFORE_IDLE: 1000 * 30
};

export const MEDICALLY_REVIEWED_BY = 'Medically reviewed by';
export const WRITTEN_BY = 'Written by';
export const HCP_TYPE = 'health_care_provider_acquirable';
export const ADS_SUPPRESSED_TYPE = 'advertising_suppressed';
export const SPECIALITY_DRUG = 'specialty_drug';
export const OZEMPIC_DESC =
  'Ozempic is a GLP-1 agonist used to improve blood sugar control in people with Type 2 diabetes and reduce cardiovascular events. It is also used off-label for weight loss. No generic version available.';

export const EXCLUDE_SPANISH_LINK = [
  '/content',
  'what-is',
  'dosage',
  'side-effects',
  'coupons'
];

export const SOURCESTOLAZYLOAD = [
  'cdn.cookielaw.org',
  'static.legitscript.com',
  'cdn-cookie-law.images.singlecare.com',
  'https://fomo.com'
];
//AB test full screen coupon page FAQS
export const COUPONPAGEFAQS = [
  {
    Question: 'I already have insurance. Can I still get the SingleCare price?',
    Answer: [
      'SingleCare works whether or not you have insurance and we might even beat your prescription copay. It’s always a good idea to check the SingleCare price!'
    ]
  },
  {
    Question: 'Do I have to join? How much does it cost?',
    Answer: [
      'SingleCare is always free to use. In many cases, additional Member Bonus Savings might be available if you sign up for a free SingleCare membership.'
    ]
  },
  {
    Question: 'How does SingleCare membership work?',
    Answer: [
      `It’s totally free to join and lets you access special Member Bonus Savings. <a href="#openSignupFromCouponPage">Click here</a> to join in just seconds. Be sure to sign-up using the same legal name and birth date used on your prescriptions. This is how we apply your Member Bonus Savings.`
    ]
  },
  {
    Question: 'What if my pharmacy cannot process my coupon?',
    Answer: [
      'SingleCare is valid at over 35,000 pharmacies nationwide. If our website displays a price for your pharmacy and there’s a problem with your pharmacy processing this discount, please have them call our dedicated pharmacist support line at 800-960-6918.'
    ]
  }
];
